<mwe-modal [model]="popupModel()">
  <div
    class="modal-body scrollbar-thin p-0 rounded-bottom"
    tabindex="0"
    ngbAutofocus
    [attr.aria-label]="'upload.previewBodyLabel' | translate"
  >
    @switch (loadedData.extension) {
      @case ('PDF') {
        <div class="overflow-auto" style="min-height: 70dvh">
          <object class="w-100" height="600" [data]="safeUrl()" type="application/pdf"></object>
        </div>
      }
      @default {
        <img class="img-fluid" src="{{ loadedData.base64 }}" alt />
      }
    }
  </div>
</mwe-modal>
